import React, { useState, useEffect, Fragment } from "react";
import { Menu, Transition, Listbox } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const Dropdown = (props: {
  isTime: boolean;
  isFrequency: boolean;
  frequency: any;
  className:any;
  date: any;
  onClick?: any;
  onSelectTime?: any;
  onSelectLength?: any;
  initialTimeOption?: any;
  initialLengthOption?: any;
}) => {
  /**
   * TODO - Need to create a  map function that loops through the array of options
   */
  const [selected, setSelected] = useState(undefined);
  const [selectedTimeOption, setSelectedTimeOption] = useState(props.initialTimeOption);
  const [selectedLengthOption, setSelectedLengthOption] = useState(props.initialLengthOption);
  let fillClasses = "";
  let activeClasses: any;
  let activeClasses2;
  let activeOptions: any;
  useEffect(() => {
    if(props.onSelectTime || props.onSelectLength) {

      props.onSelectTime && props.onSelectTime(selectedTimeOption);
      props.onSelectLength && props.onSelectLength(selectedLengthOption);
    }
  }, [selectedTimeOption, selectedLengthOption]);

  if (props.isTime && !props.isFrequency) {
    activeClasses = (
      <>
        {" "}
        <Listbox.Button
          className={`${props.className} h-10 inline-flex  justify-center rounded-lg bg-white px-4 py-2 text-sm font-bold text-gray-700 shadow-sm hover:bg-gray-50`}
        >
          <span className="block truncate">{selected ? selected : "Make Selection"}</span>
        </Listbox.Button>
      </>
    );
    activeOptions = (
      <>
        {" "}
        <div className="py-1">
          {props.frequency.map((option:any ) => 
          (
            <Listbox.Option
              key={option}
              className={({ active }) =>
                classNames(
                  active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                  "block px-4 py-2 text-sm"
                )
              }
              value={option}
            >
              {({ selected, active }) => (
                <>
                  <span
                    className={classNames(
                      selected ? "font-semibold" : "font-normal",
                      "block truncate"
                    )}
                  >
                    {selected ? setSelectedTimeOption(option) : null}
                    {option}
                  </span>
                </>
              )}
            </Listbox.Option>
          ))}
        </div>
      </>
    );
  } else if (!props.isTime && props.isFrequency) {
    activeClasses = (
      <>
        {" "}
        <Listbox.Button
           className={`${props.className} h-10 inline-flex  justify-center rounded-lg bg-white px-4 py-2 text-sm font-bold text-gray-700 shadow-sm hover:bg-gray-50`}
        >
          <span className="block truncate">{selected ? selected : "Make Selection"}</span>
        </Listbox.Button>
      </>
    );
    activeOptions = (
      <>
        {" "}
        <div className="py-1">
          {props.frequency.map((option:any) => (
            <Listbox.Option
              key={option}
              className={({ active }) =>
                classNames(
                  active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                  "block px-4 py-2 text-sm"
                )
              }
              value={option}
            >
              {({ selected, active }) => (
                <>
                  <span
                    className={classNames(
                      selected ? "font-semibold " : "font-normal",
                      "block truncate"
                    )}
                  >
                    {selected ? setSelectedLengthOption(option) : null}
                    {option}
                  </span>
                </>
              )}
            </Listbox.Option>
          ))}
        </div>
      </>
    );
  } else {
    activeClasses = (
      <>
        {" "}
        <Listbox.Button className={`${props.className} inline-flex  h-14 place-items-center place-content-center rounded-xl  bg-white px-4 py-2 text-sm font-medium text-gray-700  hover:bg-gray-50 focus:outline-none`}>
          <span className="block truncate">
            {props.date ? props.date : "Currency Options"}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
      </>
    );
    activeOptions = (
      <div className="py-1">
        <Listbox.Option
          key={1}
          className={({ active }) =>
            classNames(
              "inline-flex w-full",
              active ? "bg-gray-100 text-gray-900" : "text-gray-700",
              "block px-4 py-2 text-sm"
            )
          }
          value={props.date}
        >
          {({ selected, active }) => (
            <>
              <button
                type="button"
                className={classNames(
                  "inline-flex w-full",
                  active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                  "block px-4 py-2 text-sm"
                )}
                onClick={props.onClick}
              >
                <img
                  className="mr-2 h-6 w-6"
                  aria-hidden="true"
                  src="https://static.alchemyapi.io/images/assets/1839.png"
                />
                {props.date ? (
                  "Choose"
                ) : (
                  <h6 className="font-bold text-md ml-5 my-auto">
                    Binance Coin
                  </h6>
                )}
              </button>
            </>
          )}
        </Listbox.Option>
      </div>
    );
  }
  return (
    <Listbox
      as="div"
      className={`relative inline-block text-left ${fillClasses}`}
      value={selected}
      onChange={setSelected}
    >
      {({ open }) => (
        <>
          <div className="relative mt-1">
            {activeClasses}

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute right-0 z-10 mt-2 w-52 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {activeOptions}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
};
export default Dropdown;
